export default __webpack_public_path__ + "static/media/location.b7b758ba.svg";